import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import SideBar from '@components/Layout/SideBar'
import Footer from '@components/Layout/Footer'
import './Styles/App.css'

// Lazy load components
const Home = lazy(() => import('@pages/Home/HomePage'))
const Posts = lazy(() => import('@pages/Posts/PostsPage'))
const PostArticle = lazy(() => import('@pages/Posts/PostArticle'))
const FilteredPosts = lazy(() => import('@pages/Posts/FilteredPosts'))
const NewsPage = lazy(() => import('@pages/News/NewsPage'))
const AboutPage = lazy(() => import('@pages/About/AboutPage'))
const NotFoundPage = lazy(() => import('@pages/NotFound/NotFoundPage'))

function App() {
  return (
    <Router basename="/blog/">
      <div className="app">
        <SideBar />
        <main className="main-content">
          <Suspense fallback={<div className="loading">Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/posts" element={<Posts />} />
              <Route path="/posts/:slug" element={<PostArticle />} />
              <Route path="/posts/:type/:value" element={<FilteredPosts />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
